// extracted by mini-css-extract-plugin
export var aiStarIcon = "_9p-4";
export var closeButton = "_9p-6";
export var dismissButton = "_9p-3";
export var editImageWithAiContainer = "_9p-8";
export var imageUploadWrapper = "_9p-7";
export var misspelledWord = "_9p-5";
export var spellCheckContainer = "_9p-2";
export var spin = "_9p-1";
export var spinning = "_9p-0";